import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

import { Modal } from '@onl-web/shared/components'

const CARD_MAX_WIDTH = 300
const CARD_PADDING_TOP = 32
const CARD_PADDING_SIDE = 20
const CARD_PADDING_BOTTOM = 20
const CARD_BORDER_RADIUS = 16
const CARD_GAP = 32
const BUTTON_HEIGHT = 48
const BUTTON_BORDER_RADIUS = 12
const BACKDROP_Z_INDEX = 9999
const CONTENT_Z_INDEX = 10000

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const Backdrop = styled(Modal.Backdrop)`
  position: fixed;
  inset: 0;
  z-index: ${BACKDROP_Z_INDEX};
  background: rgba(0, 0, 0, 0.4);
  animation: ${fadeIn} 0.2s ease-out;
`

export const ContentWrapper = styled(Modal.Content)`
  position: fixed;
  inset: 0;
  z-index: ${CONTENT_Z_INDEX};
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
  overscroll-behavior: none;
`

export const Card = styled.div`
  max-width: ${CARD_MAX_WIDTH}px;
  width: calc(100% - 48px);
  padding: ${CARD_PADDING_TOP}px ${CARD_PADDING_SIDE}px ${CARD_PADDING_BOTTOM}px;
  display: flex;
  flex-direction: column;
  gap: ${CARD_GAP}px;
  background: #ffffff;
  border-radius: ${CARD_BORDER_RADIUS}px;
  box-shadow:
    0px 0px 2px rgba(0, 0, 0, 0.12),
    0px 4px 8px rgba(0, 0, 0, 0.16);
`

export const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const Title = styled.h2`
  margin: 0;
  font-family: 'Pretendard Variable', Pretendard, sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -0.3px;
  color: #1b1c1d;
  text-align: center;
`

export const Description = styled.p`
  margin: 0;
  font-family: 'Pretendard Variable', Pretendard, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: #3f4145;
  text-align: center;
  white-space: pre-line;
`

export const ConfirmButton = styled.button`
  width: 100%;
  height: ${BUTTON_HEIGHT}px;
  border: none;
  border-radius: ${BUTTON_BORDER_RADIUS}px;
  background: #1b1c1d;
  color: #ffffff;
  font-family: 'Pretendard Variable', Pretendard, sans-serif;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.08px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:active {
    opacity: 0.85;
  }
`
